import { handleSendInquiry, registerBootstrap } from "@common/utils/utils";
import Modal from "@common/bootstrapComponents/Modal.mjs";
interface AnimationSettings {
  [key: string]: JQuery.PlainObject;
}

interface ElementTargets {
  body: JQuery;
  title: JQuery;
  description: JQuery;
  link: JQuery;
  input: JQuery;
}

const animationSettings: { [stage: string]: AnimationSettings } = {
  initial: {
    body: { opacity: 0, visibility: "hidden", transform: "translateY(-6rem)" },
    title: { transform: "translateY(-50%)", clipPath: "inset(100% 0% 0% 0%)" },
    description: { transform: "translateY(-3rem)", clipPath: "inset(100% 0% 0% 0%)" },
    link: { transform: "translateY(-100%)", clipPath: "inset(100% 0% 0% 0%)" },
    input: { transform: "translateY(100%)", opacity: 0 },
  },
  show: {
    body: { transition: "all .55s ease", opacity: 1, visibility: "visible", transform: "translateY(0)" },
    title: { transition: "all .55s .25s ease-out", transform: "translateY(0%)", clipPath: "inset(0% 0% 0% 0%)" },
    description: { transition: "all .55s .25s ease-out", transform: "translateY(0%)", clipPath: "inset(0% 0% 0% 0%)" },
    link: {}, // 链接的动画将在 showAnimation 中动态处理
    input: {}, // 输入框的动画将在 showAnimation 中动态处理
  },
  close: {
    body: { opacity: 0, visibility: "hidden", transform: "translateY(-6rem)", transition: "all .4s .1s ease-out" },
    title: { transform: "translateY(-50%)", clipPath: "inset(100% 0% 0% 0%)", transition: "all .3s ease-out" },
    description: { transform: "translateY(-3rem)", clipPath: "inset(100% 0% 0% 0%)", transition: "all .3s ease-out" },
    link: { transform: "translateY(-100%)", clipPath: "inset(100% 0% 0% 0%)", transition: "all .3s ease-out" },
    input: { transform: "translateY(100%)", opacity: 0, transition: "all .3s ease-out" },
  },
};

// 应用动画设置到目标元素
const applyAnimation = (targets: ElementTargets, settings: AnimationSettings): void => {
  Object.entries(targets).forEach(([key, target]) => {
    const setting = settings[key];
    if (setting) {
      target.css(setting);
    }
  });
};

// 初始化动画（打开时准备）
const initAnimation = (targets: ElementTargets): void => applyAnimation(targets, animationSettings.initial);

// 显示动画（打开时的动画）
const showAnimation = (targets: ElementTargets): void => {
  applyAnimation(targets, animationSettings.show);

  // 动态处理链接和输入框的显示动画
  targets.link.each((index, li) => {
    $(li).css({
      transition: `all .4s ${index * 0.15 + 0.2}s ease-out`,
      transform: "translateY(0%)",
      clipPath: "inset(0% 0% 0% 0%)",
    });
  });
  targets.input.each((index, input) => {
    $(input).css({
      transition: `all .55s ${index * 0.15 + 0.15}s ease`,
      transform: "translateY(0%)",
      opacity: 1,
    });
  });
};

// 关闭动画
const closeAnimation = (targets: ElementTargets): void => {
  applyAnimation(targets, animationSettings.close);
};

// 主函数
const dialogFormInit = (inquiryOpts?: Partial<SendInquiryOpts>): void => {
  const { formId = "#DialogForm-1-Form", trigger = "#DialogForm-1-Submit", opts = {} } = inquiryOpts || {};
  const container = $("#dialogForm-1");
  if (!container.length) return;
  registerBootstrap(Modal);
  const targets: ElementTargets = {
    body: container.find(".modal-body"),
    title: container.find("#DialogForm-1-Title"),
    description: container.find(".dialogForm-1-des"),
    link: container.find(".contact-list ul > li"),
    input: container.find(".formline"),
  };

  let closeFlag = false;
  let relatedTarget: HTMLElement | undefined = undefined;
  container.on("show.bs.modal", (e) => {
    // @ts-ignore
    relatedTarget = e.relatedTarget || undefined;
    initAnimation(targets);
  });

  container.on("shown.bs.modal", () => showAnimation(targets));

  container.on("hide.bs.modal", (e) => {
    if (!closeFlag) {
      e.preventDefault();
      closeFlag = true;
      closeAnimation(targets);
      setTimeout(() => container.modal("hide"), 600);
    } else {
      closeFlag = false;
    }
  });

  handleSendInquiry({
    formId,
    trigger,
    opts: {
      onBeforeSend: (data) => {
        $("#DialogForm-1-Submit").addClass("is-Sending").prop("disabled", true);
        if (opts && opts.onBeforeSend) {
          opts.onBeforeSend(data);
        }
      },
      onSuccess: (res, trigger) => {
        $("#DialogForm-1-Submit").addClass("is-Send").prop("disabled", false);
        if (opts && opts.onSuccess) {
          const rt = opts.onSuccess(res, trigger ?? relatedTarget, container) as void | boolean;
          if (rt) return rt;
        }
        location.href = "/page/thanks.html";
      },
      onReject: (res, trigger) => {
        window.alert(res.msg);
        $("#DialogForm-1-Submit").removeClass("is-Send is-Sending").prop("disabled", false);
        if (opts && opts.onReject) {
          opts.onReject(res, trigger);
        }
      },
    },
  });
};

export default dialogFormInit;
